import React from 'react';

import styles from './NoBeneficiary.module.css';

const NoBeneficiary = () => <div className={styles.noBens}>No added beneficiaries.</div>;

export default NoBeneficiary;
